export default {
  getAgentNotifications(state) {
    return state.notifications;
  },
};
